export { default, getStaticProps } from 'src/pages/Editor'
